import Vue from 'vue'
import App from './App'
import router from './router'
import Loader from './components/Loader/Loader'
import 'babel-polyfill'
import vuetify from '@/plugins/vuetify'
import 'vuetify/dist/vuetify.min.css'
import currency from 'v-currency-field'

import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/de'
import 'element-ui/lib/theme-chalk/index.css'
import 'v-currency-field/dist/index.css'

import { store } from './store'

Vue.use(ElementUI, { locale })

Vue.use(currency)

Vue.component('data-loader', Loader)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  store,
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js